import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "@volca/ui/components/ui/alert";
import {
  getAiScriptWorkbookAuthorizationMessage,
  isAiScriptWorkbookAuthorizationError,
} from "@/payroll/ai-script/utils";
import { getErrorTitle } from "./utils";

interface WorkbookLoadErrorProps {
  error: unknown;
}

export const WorkbookLoadError = ({ error }: WorkbookLoadErrorProps) => (
  <Alert color="danger">
    <AlertTitle>{getErrorTitle(error)}</AlertTitle>
    <AlertDescription>
      {isAiScriptWorkbookAuthorizationError(error)
        ? getAiScriptWorkbookAuthorizationMessage(error)
        : error instanceof Error
          ? error.message
          : "Please try again or download the Grid instead."}
    </AlertDescription>
  </Alert>
);
